module.exports = __webpack_public_path__ + "img/group.15d3f4a3.png";